/**
 * h5 用户如果未登录 不发查询券请求
 */
import React, { Component, Fragment } from 'react'
import { LangEum } from '@/constant'
import classnames from 'classnames'
import { Toast } from 'antd-mobile'
import { getNewUserCoupons, receiveCoupon } from './apis'
import { withReactTrack } from '@du/analytics-sdk'
import { createTrackConfig } from './trackConfig'
import styles from './index.module.less'
import appInstall from '@/utils/appUtils/appInstall'
import { isDuApp } from '@/utils/appUtils/getDevice'
import { BaseComponentItemPropsType, AsyncDataFnParamsType } from '@/typings/types'

const successMsgMap: any = {
  zh: '領取成功',
  'zh-TW': '領取成功',
  [LangEum['zh-MO']]: '領取成功',
  [LangEum['zh-TW2']]: '領取成功',
  en: 'Claimed successfully',
  ja: '受け取り済み',
  [LangEum['zh-SG']]: '该优惠券已领完',
  [LangEum['zh-MY']]: '该优惠券已领完',
}

const errorMsgMap: any = {
  'zh-TW': '該優惠券已領完',
  [LangEum['zh-MO']]: '該優惠券已領完',
  [LangEum['zh-TW2']]: '該優惠券已領完',
  en: 'We’re out of this coupon',
  ja: 'このクーポンは受取上限に達した',
  zh: '该优惠券已领完',
  [LangEum['zh-SG']]: '该优惠券已领完',
  [LangEum['zh-MY']]: '该优惠券已领完',
}

const zhTW = {
  // 券标题
  title: {
    fontSize: '0.22rem',
  },
  // 券条件
  condition: {
    fontSize: '0.09rem',
  },
  //
  moneyAmount: {
    fontSize: '0.28rem',
  },
  moneySign: {
    fontSize: '0.20rem',
  },
  // 领文案
  led: {
    fontSize: '0.30rem',
  },
}

/**
 * 字体大小
 * 金额
 */
const stylesMap: any = {
  [LangEum['zh-TW']]: zhTW,
  [LangEum['zh-MO']]: zhTW,
  [LangEum['zh-TW2']]: zhTW,
  zh: zhTW,
  [LangEum['zh-SG']]: zhTW,
  [LangEum['zh-MY']]: zhTW,
  en: {
    // 券标题
    title: {
      fontSize: '0.14rem',
      wordBreak: 'break-word',
      lineHeight: '0.16rem',
      width: '80%',
    },
    // 券条件
    condition: {
      fontSize: '0.08rem',
      lineHeight: '0.10rem',
    },
    //
    moneyAmount: {
      fontSize: '0.14rem',
    },
    moneySign: {
      fontSize: '0.14rem',
    },
    // 领文案
    led: {
      fontSize: '0.14rem',
    },
    couponTop: {
      marginTop: '0.02rem',
    },
  },
}

interface CouponType {
  condition: string
  title?: string
  moneyAmount?: string
  moneySign?: string
  couponType: 1 | 2
}

interface ItemProps {
  bgImgMap: {
    available: string
    none: string
    received: string
  }
  innerColor: string
  outerColor: string
  receiveWord: string
  coupons: CouponType[]
  outerBgImg: string
  marketingType?: 1 | 2
  receiveWordBgColor?: string
  receiveWordColor?: string; // 字体颜色
  availableFontColor?: string
  receiveWordBgImg?: string
}

interface IProps extends BaseComponentItemPropsType<ItemProps, Partial<IState>> {}

const statusMap = {
  available: 1, // 可领取
  none: 2, // 领光了
  received: 3, // 已领取
}

const statusTheMap: any = {
  1: 'available',
  2: 'none',
  3: 'received',
}

function CouponsWrapper(props: {
  coupons: CouponType[]
  stylesConfig: any
  lang: string
  couponStatus: 1 | 2 | 3
  availableFontColor?: string
}) {
  const { coupons, stylesConfig, lang, couponStatus, availableFontColor } = props
  function getFontColorStyle(obj: any) {
    // 待领取白色 其他黑色
    if (couponStatus === 1) {
      return {
        ...(obj || {}),
        color: availableFontColor || '#fff',
      }
    }
    return obj
  }
  return (
    <div className={styles['coupons-wrapper']}>
      {coupons.map((ele) => {
        let content = (
          <Fragment>
            <span
              style={getFontColorStyle(stylesConfig.moneySign || {})}
              className={styles['money-sign']}
            >
              {ele.moneySign}
            </span>
            <span
              style={getFontColorStyle(stylesConfig.moneyAmount || {})}
              className={styles['money-amount']}
            >
              {ele.moneyAmount}
            </span>
          </Fragment>
        )
        if (ele.couponType === 1 && ele.title) {
          content = (
            <span
              style={getFontColorStyle(stylesConfig.title || {})}
              className={styles['coupon-title']}
            >
              {ele.title}
            </span>
          )
        } else if (ele.couponType === 2 && lang === 'en') {
          console.error(ele.couponType, 'ele.couponType....')
          content = (
            <span
              style={getFontColorStyle(stylesConfig.title || {})}
              className={styles['coupon-title']}
            >
              {`${ele.moneySign} ${ele.moneyAmount}`}
            </span>
          )
        }
        return (
          <div key={ele.moneyAmount || ele.title} className={styles['coupon-item-wrapper']}>
            <div
              style={getFontColorStyle(stylesConfig.couponTop || {})}
              className={styles['coupon-top']}
            >
              {content}
            </div>
            <div
              style={getFontColorStyle(stylesConfig.condition || {})}
              className={styles['coupon-bottom']}
            >
              {ele.condition}
            </div>
          </div>
        )
      })}
    </div>
  )
}

const defaultImg = 'https://cdn.poizon.com/node-common/1ba1e9fd7626e5523e15c0380b32002c.png'

function Led(props: any) {
  const {
    receiveCoupon,
    couponStatus,
    stylesConfig,
    receiveWord,
    receiveWordBgImg,
    receiveWordBgColor,
    receiveWordColor,
  } = props

  function getStyle(obj: any) {
    const nextObj = { ...obj }
    if (couponStatus === statusMap.available) {
      nextObj.color = receiveWordColor || '#4C70B1'
      if (receiveWordBgImg) {
        return {
          ...nextObj,
          backgroundImage: `url('${receiveWordBgImg}')`
        }
      }
      if (receiveWordBgColor) {
        return {
          ...nextObj,
          backgroundColor: receiveWordBgColor,
        }
      }
    }
    return {
      ...nextObj,
      // backgroundImage: `url('${defaultImg}')`,
    }
  }

  // 可领取状态
  return (
    <div
      onClick={receiveCoupon}
      className={classnames({
        [styles['right']]: true,
        [styles['receive-word-available']]: statusMap.available === couponStatus,
        [styles['receive-word-none']]: statusMap.none === couponStatus,
        [styles['receive-word-received']]: statusMap.received === couponStatus,
      })}
      style={getStyle(stylesConfig.led || {})}
    >
      {receiveWord}
    </div>
  )
}

interface IState {
  couponStatus: 1 | 2 | 3
}
@withReactTrack({ createTrackConfig })
class Coupon extends Component<IProps, IState> {
  static config = {
    name: 'poizon-coupon',
  }

  // 服务端预取数据
  // static async asyncData({ editConfig, req }: AsyncDataFnParamsType<ItemProps>) {
  //   const { lang, local } = editConfig
  //   const res = await getNewUserCoupons(
  //     {
  //       language: lang,
  //       countryCode: local,
  //       marketingType: 1,
  //     },
  //     { language: lang, countryCode: local },
  //     req
  //   )
  //   return {
  //     couponStatus: res.data.state,
  //     isTrusted: true,
  //   }
  // }

  constructor(props: IProps) {
    super(props)
    this.state = {
      // couponStatus: props?.prefetchData?.isTrusted ? props?.prefetchData?.couponStatus : 1,
      couponStatus: 1,
    }
  }

  componentDidMount() {
    // just Test
    if (!this.props?.prefetchData?.isTrusted) {
      this.queryNewUserCoupons()
    }
  }

  queryNewUserCoupons = async () => {
    // H5 未登录 返回
    if (!isDuApp()) {
      return
    }
    if (this.props?.prefetchData?.isTrusted) {
      return
    }
    const { lang, local, id } = this.props?.editConfig
    const { marketingType = 1 } = this.props?.propsConfig
    const self = this
    getNewUserCoupons(
      {
        language: lang,
        countryCode: local,
        marketingType,
        uniqueMark: id,
      },
      { language: lang, countryCode: local }
    ).then((res) => {
      self.setState({
        couponStatus: res.data.state,
      })
    })
  }

  receiveCoupon = () => {
    const { lang, local, id } = this.props?.editConfig
    const self = this
    // H5 未登录 返回
    if (!isDuApp()) {
      appInstall()
      return
    }
    const { marketingType = 1 } = this.props?.propsConfig
    if (this.state.couponStatus !== 1) {
      return
    }
    receiveCoupon(
      {
        language: lang,
        countryCode: local,
        marketingType,
        uniqueMark: id,
      },
      { language: lang, countryCode: local }
    )
      .then((res) => {
        if (!res.data.receiveFlag) {
          Toast.info(errorMsgMap[lang])
        } else {
          Toast.info(successMsgMap[lang])
        }
        self.queryNewUserCoupons()
      })
      .catch((error) => {
        self.queryNewUserCoupons()
        console.log(error, 'error...')
      })
  }

  render() {
    const { propsConfig } = this.props
    const { couponStatus } = this.state
    if (!propsConfig) {
      return <div>填完必要参数</div>
    }
    if (!couponStatus) {
      // loading
      return <div>&nbsp;</div>
    }
    const {
      innerColor,
      bgImgMap,
      coupons,
      receiveWord,
      receiveWordColor,
      outerColor,
      receiveWordBgImg,
      receiveWordBgColor,
      availableFontColor,
    } = propsConfig
    if (!bgImgMap || !coupons) {
      return <div>填完必要参数</div>
    }
    const { lang } = this.props?.editConfig
    const stylesConfig = stylesMap[lang || 'zh-TW'] || zhTW
    return (
      <div
        data-track-click={'poizon_venue_component_content_click'}
        data-track-exposure={'poizon_venue_component_content_exposure'}
        className={styles['poizon-coupon-wrapper']}
        style={{
          background: outerColor || '#000',
        }}
      >
        {/* <img className={styles['wrapper-bg-img']} src={outerBgImg} alt="" /> */}
        <div style={{ background: innerColor }} className={styles['poizon-coupon-content']}>
          <div className={styles['left']}>
            <img
              src={(bgImgMap as any)[statusTheMap[couponStatus]]}
              className={styles['bg-img']}
              alt=""
            />
            {lang !== 'en' && (
              <CouponsWrapper
                couponStatus={couponStatus}
                lang={lang}
                stylesConfig={stylesConfig}
                coupons={coupons}
                availableFontColor={availableFontColor}
              />
            )}
          </div>
          <Led
            receiveCoupon={this.receiveCoupon}
            couponStatus={couponStatus}
            stylesConfig={stylesConfig}
            receiveWord={receiveWord}
            receiveWordColor={receiveWordColor}
            receiveWordBgImg={receiveWordBgImg}
            receiveWordBgColor={receiveWordBgColor}
          />
          {/* <div
            onClick={this.receiveCoupon}
            className={classnames({
              [styles['right']]: true,
              [styles['receive-word-available']]: statusMap.available === couponStatus,
              [styles['receive-word-none']]: statusMap.none === couponStatus,
              [styles['receive-word-received']]: statusMap.received === couponStatus,
            })}
            style={stylesConfig.led || {}}
          >
            {receiveWord}
          </div> */}
        </div>
      </div>
    )
  }
}

Coupon.config = {
  name: 'poizon-coupon',
}

export default Coupon
